import {LINE_CHAR_LIMIT} from '../Config/config'

export const calculateYlabels = (yMin, yMax) => {
  let yMinRound = Math.floor(yMin / 1000) * 1000
  let yMaxRound = Math.ceil(yMax / 1000) * 1000 + 1000
  let stepCount = 1000
  if (yMaxRound - yMinRound <= 10000) {
    while (yMaxRound - yMinRound <= 10000) {
      if (yMaxRound <= 100000) yMaxRound = yMaxRound + 1000
      if (yMinRound >= 1000 && yMaxRound - yMinRound <= 10000) yMinRound = yMinRound - 1000
    }
  } else if (yMaxRound - yMinRound < 100000) {
    stepCount = (yMaxRound - yMinRound) / 9
    stepCount = Math.round(stepCount / 1000) * 1000
    yMinRound = yMinRound - stepCount > 0 ? yMinRound - stepCount : yMinRound
    yMaxRound = stepCount * 10 + yMinRound
    while (yMaxRound < yMax) yMaxRound += stepCount
  }
  return [yMinRound, yMaxRound, stepCount]
}

export function roundToNearest(value, multiple, roundMin) {
  let rounded
  // if rounding min value, round down, else round up
  if (roundMin) {
    rounded = Math.floor(value / multiple) * multiple
    return rounded
  } else {
    rounded = Math.ceil(value / multiple) * multiple
    return rounded
  }
}

export function generateMinMaxOnZoom(start, end, minLimit, maxLimit) {
  // Adjust the start and end to the nearest 1000 or 100 based on the range
  let step
  const roundMin = true
  if (Math.abs(end - start) <= 1000) {
    start = roundToNearest(start, 1000, roundMin)
    end = roundToNearest(end, 1000, !roundMin)
    return {min: start, max: end, diff: 100}
  } else {
    start = roundToNearest(start, 1000, roundMin)
    end = roundToNearest(end, 1000, !roundMin)
    step = 1000
    if (start === minLimit && start !== minLimit) {
      start += step
    }
    if (end === maxLimit && end !== maxLimit) {
      end -= step
    }
  }
  // Apply min and max limits to start and end
  start = Math.max(start, minLimit)
  end = Math.min(end, maxLimit)

  // Calculate the range length
  const rangeLength = Math.abs(end - start)

  // Determine the maximum possible step size that is a multiple of 1000 or 100 based on the range
  const numElements = Math.min(10, Math.floor(rangeLength / step) + 1)
  let maxStepSize = Math.floor(rangeLength / (numElements - 1))

  // Ensure the step size is a multiple of 1000 or 100 based on the range
  if (Math.abs(end - start) < 1000) {
    maxStepSize = Math.max(100, Math.floor(maxStepSize / 100) * 100)
  } else {
    maxStepSize = Math.max(1000, Math.floor(maxStepSize / 1000) * 1000)
  }

  // Generate the array using the calculated step size
  let array = []
  for (let i = start; i <= end; i += maxStepSize) {
    array.push(i)
  }
  // Ensure the array has at least 5 elements if possible
  while (array.length < 8 && maxStepSize > step) {
    maxStepSize = Math.floor(maxStepSize / 2)
    array = []
    for (let i = start; i <= end; i += maxStepSize) {
      array.push(i)
    }
  }
  return {min: array[0], max: array.at(-1), diff: maxStepSize}
}

export const customTooltipCallback = (context, chartRef, tooltipPosition, setTooltipVisible) => {
  if (context.tooltip.opacity === 0) {
    setTooltipVisible(false)
    return
  }

  const chart = chartRef.current
  const canvas = chart.canvas
  const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas
  chart.position = null

  if (canvas) {
    setTooltipVisible((prev) => !prev)
    const left = positionX + context.tooltip.caretX + 'px'
    let bottom, top
    if (tooltipPosition === 'top') {
      // positionY starting of canvas relative to parent
      // context.tooltip.caretY position of tooltip caret from canvas starting
      bottom = chart.canvas.parentNode.parentElement.parentElement.clientHeight - context.tooltip.caretY + 'px'
      if (chart.position?.bottom !== bottom) {
        chart.position = {left, bottom}
      }
    } else {
      top = positionY + context.tooltip.caretY + 'px'
      if (chart.position?.top !== top) {
        chart.position = {top, left, bottom}
      }
    }
  }
}

/**
 * Splits a string into an array of substrings with a maximum length of LINE_CHAR_LIMIT.
 * If a substring is split, a hyphen is added to the end of the substring.
 */
export const splitString = (str) => {
  const result = []
  let currentString = ''
  for (let i = 0; i < str.length; i++) {
    currentString += str[i]
    if (currentString.length === LINE_CHAR_LIMIT) {
      if (i !== str.length - 1) currentString += '-'
      result.push(currentString)
      currentString = ''
    }
    if (i === str.length - 1 && currentString !== '') result.push(currentString)
  }
  return result
}
